// Upload generated invoice PDF to backend and obtain a public URL.

import { api } from "@/lib/api";

/**
 * Upload a PDF Blob to the backend and return the public absolute URL.
 *
 * @param {Blob} pdfBlob
 * @param {string} transactionId
 * @param {string} [filename]
 * @returns {Promise<{ id: string, url: string, urlPath: string }>}
 */
export async function uploadInvoicePdf(pdfBlob, transactionId, filename = "invoice.pdf") {
  if (!pdfBlob) throw new Error("PDF blob tidak tersedia");
  const form = new FormData();
  form.append("transaction_id", transactionId);
  form.append("file", pdfBlob, filename);
  const { data } = await api.post("/invoices/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  return {
    id: data.id,
    urlPath: data.url_path,
    url: `${base}${data.url_path}`,
  };
}

/**
 * Copy text to the clipboard. Falls back to a hidden textarea if Clipboard API
 * is unavailable (older browsers / non-https origins).
 */
export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (_) { /* fall through */ }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
    return true;
  } catch (_) {
    return false;
  }
}
